import BenchlingConfig from 'BenchlingConfig';

export default function includeAnalysesInSearch(): boolean {
  return BenchlingConfig.ENABLE_ANALYSIS_TOOL_WITHOUT_INSIGHTS;
}
